/**
 * The server's message when a Team member sends to a Circle they aren't
 * assigned to, to Everyone without being an Admin, or after their Team member
 * account was removed; null for any other error. Matches the backend's
 * messages in domain/notices/teamMemberAudience.ts.
 * Usually the dashboard has already hidden those Circles, but the server checks
 * the current assignment, which may have changed since the Team member signed in.
 */
export function audienceRefusalMessage(error: unknown): string | null {
  if (!(error instanceof Error)) return null;
  return /can't send to this circle|only admins can send to everyone|team member account wasn't found/i.test(error.message)
    ? error.message
    : null;
}
